import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://recommendation-system-demo.onrender.com/api';

const api = {
  // 健康檢查
  checkHealth: async () => {
    const response = await axios.get(`${API_BASE_URL}/health`);
    return response.data;
  },

  // 聊天相關 - 統一使用 /chat 端點
  sendMessage: async (conversationId, message) => {
    const requestData = { message };
    if (conversationId) {
      requestData.conversationId = conversationId;
    }
    
    const response = await axios.post(`${API_BASE_URL}/chat`, requestData);
    return response;
  },

  clearChat: async (conversationId) => {
    const response = await axios.post(`${API_BASE_URL}/chat/clear`, null, {
      params: { conversationId }
    });
    return response.data;
  },

  // 檢查排名狀態
  checkRankingStatus: async (conversationId) => {
    const response = await axios.get(`${API_BASE_URL}/ranking/${conversationId}/status`);
    return response.data;
  },

  clearConversation: async (conversationId) => {
    const response = await axios.post(`${API_BASE_URL}/chat/clear`, null, {
      params: { conversationId }
    });
    return response.data;
  },

  // 匯出聊天記錄
  exportConversation: async (data) => {
    const requestData = {
      email: data.email,
      subject: '智慧照顧產品推薦結果', // 🔥 改進主題
      conversationData: data.conversation
    };
    
    // 🔥 新增：如果有conversationId，一併傳送
    if (data.conversationId) {
      requestData.conversationId = data.conversationId;
    }
    
    const response = await axios.post(`${API_BASE_URL}/email/send`, requestData);
    return response;
  },

  // 產品相關
  getAllProducts: async () => {
    const response = await axios.get(`${API_BASE_URL}/products`);
    return response.data;
  },

  getProductsByCategory: async (category) => {
    const response = await axios.get(`${API_BASE_URL}/products/category/${category}`);
    return response.data;
  },

  getCategories: async () => {
    const response = await axios.get(`${API_BASE_URL}/products/categories`);
    return response.data;
  },

  // 產品排名相關
  generateRanking: async (rankingRequest) => {
    const response = await axios.post(`${API_BASE_URL}/ranking/generate`, rankingRequest);
    return response.data;
  },

  getRanking: async (conversationId) => {
    const response = await axios.get(`${API_BASE_URL}/ranking/${conversationId}`);
    return response.data;
  },

  getNextBatch: async (conversationId, batchSize = 3) => {
    const response = await axios.post(`${API_BASE_URL}/ranking/${conversationId}/next-batch?batchSize=${batchSize}`);
    return response.data;
  },

  getRankingDetails: async (conversationId) => {
    const response = await axios.get(`${API_BASE_URL}/ranking/${conversationId}/details`);
    return response.data;
  },
};

// 請求攔截器 - 可以在這裡添加認證 token 等
axios.interceptors.request.use(
  config => {
    // 可以在這裡添加認證頭等
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 響應攔截器 - 統一處理錯誤
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      // 服務器響應錯誤
      console.error('API Error:', error.response.data);
    } else if (error.request) {
      // 請求發送失敗
      console.error('Network Error:', error.request);
    } else {
      // 其他錯誤
      console.error('Error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default api; 